import React, { useState } from "react";
import { Button, Card, Dropdown } from "react-bootstrap";
import {
  FaBullhorn,
  FaUser,
  FaChartPie,
  FaBell,
  FaDatabase,
  FaClock,
  FaComment,
  FaCalendarDay,
  FaBuilding,
  FaPalette,
  FaEnvelope,
  FaBook,
  FaPlus,
  FaCloudDownloadAlt,
  FaCheck,
  FaRegQuestionCircle,
  FaTimes,
  FaUsers,
  FaCalendarPlus,
  FaComments,
  FaRetweet,
  FaPaperPlane,
  FaFileDownload,
  FaFileInvoice,
  FaBan,
  FaStickyNote,
  FaUserClock,
  FaColumns
} from "react-icons/fa";

import { FaCircleInfo, FaGraduationCap, } from "react-icons/fa6";
import PopUpTimeLine from "../specific/popUpTimeLine";
import { downloadFileDefault } from "../../utils/downloadPdf";
import { downloadIncidentZIP } from "../../utils/downloadIncident";
import PDFPreview from "../../utils/pdfPREV";
import { FaArrowsRotate } from "react-icons/fa6";
import Spinner from 'react-bootstrap/Spinner';
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GetIncidentActivityTypesService } from "../../Services/incidentService";


const ICONS = {
  FaBullhorn: FaBullhorn,
  FaUser: FaUser,
  FaChartPie: FaChartPie,
  FaBell: FaBell,
  FaDatabase: FaDatabase,
  FaClock: FaClock,
  FaComment: FaComment,
  FaCheck: FaCheck,
  FaRegQuestionCircle: FaRegQuestionCircle,
  FaUsers: FaUsers,
  FaCalendarDay: FaCalendarDay,
  FaTimes: FaTimes,
  FaBuilding: FaBuilding,
  FaPalette: FaPalette,
  FaEnvelope: FaEnvelope,
  FaBook: FaBook,
  FaCalendarPlus: FaCalendarPlus,
  FaComments: FaComments,
  FaRetweet: FaRetweet,
  FaPlus: FaPlus,
  FaArrowsRotate: FaArrowsRotate,
  FaFileDownload: FaFileDownload,
  FaFileInvoice: FaFileInvoice,
  FaGraduationCap: FaGraduationCap,
  FaBan: FaBan,
  FaStickyNote: FaStickyNote,
  FaUserClock: FaUserClock,
  FaColumns: FaColumns,
  FaCircleInfo: FaCircleInfo,
};

function CommonCard({
  title,
  children,
  icon,
  actividad,
  incidentId,
  incidentData,
  test,
}) {

  const [t] = useTranslation("commoncard")
  const [showModal, setShowModal] = useState(false);
  const [activityType, setActivityType] = useState("");
  const IconComponent = ICONS[icon] || null;
  const [loading, setLoading] = useState(false);
  const [activityTypes, SetActivityTypes] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleEyeClick = (activityType) => {
    setActivityType(activityType);
    setShowModal(true);
  };

  const handleDownloadClick = (incidentData) => {


    setLoading(true)

    //para que salga el spinner  

    setTimeout(() => {
      //esperar hasta que se descargue el zip
      downloadIncidentZIP(incidentData);
      setLoading(false)
    }, 500);

  };

  const handleTestClick = () => {
    alert("Se ha enviado un corre de prueba a la dirección establecida");
  };

  useEffect(() => {
    const getActivityTypes = async () => {

      const ActivityTypesNames = await GetIncidentActivityTypesService();
      SetActivityTypes(ActivityTypesNames);
      setIsLoaded(true);
    };
    getActivityTypes();
  }, []);

  return (
    <Card className="mt-3 custom-shadow common-card-card">
      {/* Contenido principal de la Card */}
      <Card.Body>
        {/* Píldora de título */}
        <div className="common-card-card-title-container">
          <Card className="common-card-card-title">
            {IconComponent && <IconComponent size={20} />}

            <span className="common-card-card-text ">{title}</span>
          </Card>
          {actividad && (
            <Dropdown>
              <Dropdown.Toggle className="common-card-card-title common-card-card-title-add-activity custom-shadow">
                {<FaPlus size={20} />}
                <span className="common-card-card-text common-card-card-text-activity ">
                  {t("commonCard.addActivity")}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {actividad === "responsible" ? (
                  <>
                    <Dropdown.Item
                      onClick={() =>
                        // handleEyeClick("Comentario del responsable")
                        handleEyeClick(activityTypes[5])
                      }
                    >
                      {t("commonCard.comment")}

                    </Dropdown.Item>

                    <Dropdown.Item
                      // onClick={() => handleEyeClick("Propuesta de reunión")}
                      onClick={() => handleEyeClick(activityTypes[11])}
                    >
                      {t("commonCard.meetingProposal")}
                    </Dropdown.Item>

                    <Dropdown.Item
                      // onClick={() => handleEyeClick("Acta de reunión")}
                      onClick={() => handleEyeClick(activityTypes[0])}
                    >
                      {t("commonCard.meetingRecord")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      // onClick={() =>
                      //   handleEyeClick("Ampliación de plazo")
                      // }
                      onClick={() => handleEyeClick(activityTypes[1])}
                    >
                      {t("commonCard.periodExtension")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      // onClick={() =>
                      //   handleEyeClick("Cancelación")
                      // }
                      onClick={() => handleEyeClick(activityTypes[3])}
                    >
                      {t("commonCard.cancellation")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      // onClick={() =>
                      //   handleEyeClick("Propuesta de resolución")
                      // }
                      onClick={() => handleEyeClick(activityTypes[10])}
                    >
                      {t("commonCard.resolutionProposal")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      // onClick={() =>
                      //   handleEyeClick("Nota responsable")
                      // }
                      onClick={() => handleEyeClick(activityTypes[8])}
                    >
                      {t("commonCard.note")}
                    </Dropdown.Item>
                  </>
                ) : (
                  <>
                    <Dropdown.Item
                      // onClick={() =>
                      //   handleEyeClick("Comentario del informante")
                      // }
                      onClick={() => handleEyeClick(activityTypes[4])}
                    >
                      {t("commonCard.comment")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      // onClick={() => handleEyeClick("Petición de reunión")}
                      onClick={() => handleEyeClick(activityTypes[9])}
                    >
                      {t("commonCard.meetingReq")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      // onClick={() => handleEyeClick("Nota informante")}
                      onClick={() => handleEyeClick(activityTypes[7])}
                    >
                      {t("commonCard.note")}
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}

          {incidentId && (

            <div className="common-card-card-download-incident-id-container ">
              <Button
                onClick={() => handleDownloadClick(incidentData)}
                className="common-card-card-title common-card-card-title-incident-download custom-shadow  background-gradient"
              >

                {loading ?
                  <>
                    <Spinner animation="border" className="spinner" />
                    <span className="common-card-card-text">{t("commonCard.downloading")}</span>

                  </>
                  :
                  <>
                    <FaCloudDownloadAlt size={20} />
                    <span className="common-card-card-text">{t("commonCard.downloadIncident")}</span>

                  </>
                }


              </Button>
              <Card className="common-card-card-title common-card-card-title-incident-id custom-shadow">
                <span className="common-card-card-text common-card-card-title-incident-id-text">
                  {incidentId}
                </span>
              </Card>
              {/* <PDFPreview incidentData={incidentData} /> */}  {/* comprobar los pdf con un preview que se actualiza sin tener que descargar el caso */}
            </div>
          )}
          {test && (
            <div className="common-card-card-download-incident-id-container">
              <Button
                onClick={() => handleTestClick()}
                className="common-card-card-test common-card-card-title-incident-download custom-shadow "
              >
                <FaPaperPlane size={20} />
                <span className="common-card-card-text">Test</span>
              </Button>
            </div>
          )}
        </div>
        <Card.Text>
          {/* Contenedor para las CaseCards */}
          {children}
        </Card.Text>
      </Card.Body>

      <PopUpTimeLine
        show={showModal}
        onHide={handleModalClose}
        activityType={activityType}
        readOnly={false}
        create={true}
      />
    </Card>
  );
}

export default CommonCard;
